Vue.component('posts-table', () => import(/* webpackChunkName: "posts-table" */ '@modulesPages/Post/Resources/assets/js/Tables/PostsTable'))

Vue.component('posts-form', () => import(/* webpackChunkName: "posts-form" */ '@modulesPages/Post/Resources/assets/js/Forms/Posts/PostsForm'))

Vue.component('posts-card', () => import(/* webpackChunkName: "posts-card" */ '@modulesPages/Post/Resources/assets/js/Cards/PostsCard'))
Vue.component('posts-card2', () => import(/* webpackChunkName: "posts-card2" */ '@modulesPages/Post/Resources/assets/js/Cards/PostsCard2'))

Vue.component('new-posts-section', () => import(/* webpackChunkName: "new-posts-section" */ '@modulesPages/Post/Resources/assets/js/Sections/NewPostsSection'))


Vue.component('posts-section', () => import(/* webpackChunkName: "posts-section" */ '@modulesPages/Post/Resources/assets/js/Sections/PostsSection'))
Vue.component('post-section', () => import(/* webpackChunkName: "post-section" */ '@modulesPages/Post/Resources/assets/js/Sections/PostSection'))
Vue.component('posts-card3', () => import(/* webpackChunkName: "posts-card3" */ '@modulesPages/Post/Resources/assets/js/Cards/PostsCard3'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Post\\Entities\\Post': 'Entrada'
    }   
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Post\\Entities\\Post': 'posts'
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'posts': 'Modules\\Post\\Entities\\Post'
	}	
}